'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const CategoryLinks = require('./category-links');
const CtaTopOffers = require('../../coupons/views/cta-top-offers');
const MerchantLinks = require('../../merchant/views/merchant-links');
const Breadcrumbs = require('../../../components/breadcrumbs');

function Categories({ payload, deps }) {
  const {
    keyAuthData,
    seoMetaData: { h1Override },
    categoryData,
    navigationMerchants,
    popularMerchants,
  } = payload;
  const { routes, breadcrumbList, showTopOffers } = deps;

  return h('article', [
    h(Header, {
      routes,
      activePage: 'categories',
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: 'modules.category.PageHeading',
    }),
    h('section.container', [
      Breadcrumbs(breadcrumbList),
      h(CategoryLinks, { routes, keyAuthData, categoryData }),
      CtaTopOffers({ routes, show: showTopOffers }),
      h(MerchantLinks, { routes, merchants: popularMerchants }),
    ]),
  ]);
}

module.exports = Categories;
